import { IAppState } from '@core/store/types'

export const getProductLists = (state: IAppState) =>
  state.productLists.productLists

export const getProductListSortOrder = (state: IAppState) =>
  state.productLists.sortOrder
